function mainRender() {
  $(function () {})
  $('#root').css('zoom', 'normal')
  let scale = document.body.clientWidth / 1080
  $('#root').css('zoom', scale)

  window.addEventListener(
    'resize',
    (function () {
      var timer
      return function () {
        if (timer) clearTimeout(timer)
        timer = setTimeout(function () {
          $('#root').css('zoom', 'normal')
          let scale = document.body.clientWidth / 1080
          $('#root').css('zoom', scale)
        }, 100)
      }
    })()
  )
  // 生成随机时间
  function generateRandomTime() {
    var hours = Math.floor(Math.random() * 15) + 1
    var minutes = Math.floor(Math.random() * 60)
    var seconds = Math.floor(Math.random() * 60)
    //总共的毫秒数
    var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

    return targetTime
  }
  function TimeDown(value) {
    //倒计时的总秒数
    var totalSeconds = parseInt(value / 1000)
    //取模（余数）
    var modulo = totalSeconds % (60 * 60 * 24)
    //小时数
    var hours = Math.floor(modulo / (60 * 60))
    modulo = modulo % (60 * 60)
    //分钟
    var minutes = Math.floor(modulo / 60)
    //秒
    var seconds = modulo % 60

    hours = hours.toString().length == 1 ? '0' + hours : hours
    minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
    seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

    //输出到页面
    $('.hours').html(hours)
    $('.minutes').html(minutes)
    $('.seconds').html(seconds)
    //延迟一秒执行自己
    if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
    } else {
      setTimeout(function () {
        TimeDown(value - 1000)
      }, 1000)
    }
  }
  TimeDown(generateRandomTime())
  // 头部固定
  $('header').addClass('stiky')
  $(document).scroll(function (e) {
    var beforScrollTop = $(document).scrollTop()
    setTimeout(function () {
      $('header').addClass('stiky')
    }, 50)
  })
  var swiper1 = new Swiper('.mySwiper1111', {
    // autoplay: {
    //   delay: 3000,
    //   stopOnLastSlide: false,
    //   disableOnInteraction: true,
    // },
  })
  // 数字框初始化
  alignmentFns.initialize()
  //加减
  $('#2').change(function () {
    var number = Number($('#2').val())
    $(this)
      .parent()
      .parent()
      .parent()
      .find('.new')
      .html(((number * Number(window.product[0].price)) / 100).toFixed(2))
    $(this)
      .parent()
      .parent()
      .parent()
      .find('.old')
      .html(
        ((number * Number(window.product[0].compare_at_price)) / 100).toFixed(2)
      )
  })
  //加减
  $('#3').change(function () {
    var number = Number($('#3').val())
    $(this)
      .parent()
      .parent()
      .parent()
      .find('.new')
      .html(((number * Number(window.product[1].price)) / 100).toFixed(2))
    $(this)
      .parent()
      .parent()
      .parent()
      .find('.old')
      .html(
        ((number * Number(window.product[1].compare_at_price)) / 100).toFixed(2)
      )
  })
  $('.link-btn').click(function () {
    let num = $('#2').val()
    const id = $(this).data('id')
    const index = $(this).data('index')
    num = index ? 1 : num
    window.location.href = '/cart/' + id + ':' + num
  })
  const tabs = $('.sp-tab')
  let currentIndex = 0
  function nextTabFunc() {
    const currentTab = tabs[currentIndex]
    currentTab.classList.add('sp-tab-ani')
    let nextIndex = (currentIndex + 1) % tabs.length
    const nextTab = tabs[nextIndex]
    setTimeout(() => {
      currentTab.classList.remove('sp-tab-ani')
    }, 2500),
      (currentIndex = (currentIndex + 1) % tabs.length),
      setTimeout(nextTabFunc, 1500)
  }
  // nextTabFunc()
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('header').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
